import React, { cloneElement, Fragment, useEffect, useState } from 'react';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { useHeading } from '../heading-context/heading-context.js';
function HeadingDynamicContent() {
    const context = useHeading();
    const [content, setContent] = useState(context.getDynamicContent());
    useEffect(() => {
        const unlisten = context.addDynamicContentListener(() => {
            setContent(context.getDynamicContent());
        });
        setContent(context.getDynamicContent());
        return () => {
            if (!isFunction(unlisten)) {
                return;
            }
            unlisten();
        };
    }, []);
    return (React.createElement(Fragment, null, content.map(({ element, id }) => cloneElement(element, { key: id }))));
}
export { HeadingDynamicContent, };
//# sourceMappingURL=heading-dynamic-content.js.map